import { useState } from 'react'
import { ChevronDown } from 'lucide-react'

interface FAQItem {
  question: string
  answer: string
}

const faqs: FAQItem[] = [
  {
    question: 'Is my email data secure?',
    answer: 'Absolutely. We use bank-level encryption and never store the content of your emails. We only process metadata like sender information to identify vendors.'
  },
  {
    question: 'Can I connect multiple email accounts?',
    answer: 'Free users can connect 1 account. Pro users can connect up to 5 Gmail or Office 365 accounts.'
  },
  {
    question: 'What happens when I NUKE a vendor?',
    answer: 'NUKE permanently deletes ALL emails from that vendor - past and future. The vendor is added to your block list, and any new emails from them are automatically deleted.'
  },
  {
    question: 'Can I cancel my Pro subscription anytime?',
    answer: "Yes! You can cancel anytime. You'll keep Pro features until the end of your billing period."
  },
  {
    question: "What's the difference between auto-delete and NUKE?",
    answer: 'Auto-delete removes emails older than your retention period (7 or 30 days). NUKE completely removes a vendor and all their emails permanently.'
  }
]

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section className="py-20 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
          Frequently Asked Questions
        </h2>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg overflow-hidden"
            >
              {/* Question Button */}
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-6 py-4 text-left bg-white hover:bg-gray-50 transition-colors"
              >
                <span className="text-lg font-medium text-gray-900">
                  {faq.question}
                </span>
                <ChevronDown
                  className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>

              {/* Answer Panel */}
              <div
                className={`overflow-hidden transition-all duration-200 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-4 pt-2 text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
